/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-31 10:56:44
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-26 11:53:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/tools/validation.ts
 */
import {
  checkCustomInfomation,
  checkActivePrice,
  checkActiveInfo,
  checkDraftInfo,
} from '../../tools/commonDataCheck';
import { checkAdvancedPrice } from './index';
import { EnumStatus } from 'src/types/common/product';
import { scroll } from 'src/tools/helper';
// import {
//   checkSalesChannelAvailableQuantity,
//   checkSalesChannelAvailablePresaleQuantity,
// } from 'src/pages/ProductEditor/tools/commonDataCheck';

export const validate = (state, action) => {
  const check = (isDraft) => {
    const {
      productInfo,
      advancedPriceSettings,
      customsInformationItems,
      priceSettings,
      // salesChannelAvailableQuantity,
      // salesChannelAvailablePresaleQuantity,
      // stock,
    } = state;
    // const { quotaEnabled, inventoryQuota, stockAvailable } = stock || {};
    const { flag: infoFlag, data: infoData } = isDraft
      ? checkDraftInfo(productInfo)
      : checkActiveInfo(productInfo) || {};
    if (infoFlag || !infoData) {
      state.productInfo = infoData;
      state.dataValid = false;
      scroll('ProductEditorProductName');
      return;
    }
    const { flag: advancedPriceFlag, data: advancedPriceSettingsData } =
      checkAdvancedPrice(advancedPriceSettings) || {};
    if (advancedPriceFlag || !advancedPriceSettingsData) {
      state.advancedPriceSettings = advancedPriceSettingsData;
      state.advancedPriceSettingsOpen = true;

      state.dataValid = false;
      //scroll\
      scroll('ProductAdvancedPriceSetting');
      return;
    }
    const { flag: customInfoFlag, data: customInfoData } =
      checkCustomInfomation(customsInformationItems) || {};
    if (customInfoFlag || !customInfoData) {
      state.customsInformationItems = customInfoData;
      state.dataValid = false;
      scroll('ProductCustomInformationSetting');
      return;
    }
    if (!isDraft) {
      const { flag: priceSettingsFlag, data: priceSettingsData } =
        checkActivePrice(priceSettings) || {};
      if (priceSettingsFlag || !priceSettings) {
        scroll('productDefaultPriceSetting');
        state.priceSettings = priceSettingsData;
        state.dataValid = false;
        return;
      }

      // const { flag: availableQuantityFlag } =
      //   checkSalesChannelAvailableQuantity(
      //     isDraft,
      //     stockAvailable,
      //     salesChannelAvailableQuantity,
      //   );
      // if (availableQuantityFlag) {
      //   state.subCollapseOpen.salesChannelAvailableQuantity = true;
      //   state.dataValid = false;

      //   scroll('salesChannelAvailableQuantity');
      //   return;
      // }
      // const calculatePreSale = () => {
      //   const _d = inventoryQuota;
      //   // - stockAvailable;
      //   // if (_d < 0) {
      //   //   return 0;
      //   // }
      //   return _d || 0;
      // };
      // console.log('inventoryQuota', inventoryQuota);
      // console.log('stockAvailable', stockAvailable);
      // const { flag: availablePresaleQuantityFlag } =
      //   checkSalesChannelAvailablePresaleQuantity(
      //     isDraft,
      //     quotaEnabled,
      //     calculatePreSale(),
      //     salesChannelAvailablePresaleQuantity,
      //   );
      // // console.log('availablePresaleQuantityFlag', availablePresaleQuantityFlag);
      // if (availablePresaleQuantityFlag) {
      //   state.subCollapseOpen.salesChannelAvailablePresaleQuantity = true;
      //   state.dataValid = false;

      //   scroll('salesChannelAvailablePresaleQuantity');
      //   return;
      // }
    }

    state.dataValid = true;
    return;
  };
  const { savedType } = action.payload || {};
  const type = savedType || state.status;
  if (type === EnumStatus.Draft) {
    check(true);
  }
  if (type === EnumStatus.Active) {
    check(false);
  }
  if (type === EnumStatus.Archived) {
    state.dataValid = true;
  }
};
